import React, { useState, useEffect } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import _ from "lodash";
import moment from "moment";
import { useTranslation } from 'react-i18next';
export default function ModalAjoutMenus(props) {
  const { t } = useTranslation();
  const [styleFadeIn, setFadeIn] = useState(true);
  const [textrepsPetit, settextrepsPetit] = useState(null);
  const [textrepsGrands, settextrepsGrands] = useState(null);
  const [buttonValid, setButtonValid] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(textrepsPetit) || !_.isEmpty(textrepsGrands)) {
      setButtonValid(true);
    } else {
      setButtonValid(false);
    }
  }, [textrepsPetit, textrepsGrands]);

  const myChangeHandler = (event) => {
    if (event.target.name === "textrepsPetit") {
      settextrepsPetit(event.target.value);
    } else {
      settextrepsGrands(event.target.value);
    }
  };

  const CloseModalAjoutRepas = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.closeModalAjoutRepas();
    }, 400);
  }, []);
  const Valider = () => {
    props.handleSubmitRepas(textrepsPetit, textrepsGrands);
  };
  return (
    <StyleRoot>
      <div
        className="modal fade show modal-skin"
        id="modalRepas"
        role="dialog"
        aria-hidden="true"
        data-radium="true"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-bg"
          role="document"
        >
          <div className="modal-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (buttonValid) Valider();
              }}
            >
              <button
                onClick={CloseModalAjoutRepas}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div className="modal-body fiche-enfant">
                <h5 className="modal-title">
                  {t('menus_section.meal_of')}{" "}
                  {moment(props.dateRepas.dateStr).format("DD MMMM YYYY")}
                </h5>
                <p className="bottom-space"></p>
                <section className="content-section">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-12">
                      <div className="form-group h-200 m-0">
                        <textarea
                          className="form-control ipt-id-baby"
                          placeholder={t('menus_section.menu_petits')}
                          name="textrepsPetit"
                          value={textrepsPetit}
                          onChange={(event) => myChangeHandler(event)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-12">
                      <div className="form-group h-200 m-0">
                        <textarea
                          className="form-control ipt-id-child"
                          placeholder={t('menus_section.menu_grands')}
                          name="textrepsGrands"
                          value={textrepsGrands}
                          onChange={(event) => myChangeHandler(event)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </section>
                <div className="d-flex justify-content-center">
                  <button
                    disabled={!buttonValid}
                    style={buttonValid ? { opacity: 1 } : { opacity: 0.25 }}
                    type="submit"
                    className="btn-gradient btn-valid"
                    data-dismiss="modal"
                    data-toggle="modal"
                    data-target="#modalModifierRepas"
                  >
                    <img
                      src="img/icon-check-white.svg"
                      className="img-fluid"
                      alt=""
                    />{" "}
                    {t('common.validate')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
